import { render, staticRenderFns } from "./PlanPartnerAgreement.vue?vue&type=template&id=7383672d&scoped=true"
import script from "./PlanPartnerAgreement.vue?vue&type=script&lang=js"
export * from "./PlanPartnerAgreement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7383672d",
  null
  
)

export default component.exports